import { render, staticRenderFns } from "./TextSearchBehaviorEditor.vue?vue&type=template&id=0afed602&"
import script from "./TextSearchBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./TextSearchBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports